import { render } from "./SPUQuery.vue?vue&type=template&id=5374f704&scoped=true"
import script from "./SPUQuery.vue?vue&type=script&lang=js"
export * from "./SPUQuery.vue?vue&type=script&lang=js"

import "./SPUQuery.vue?vue&type=style&index=0&id=5374f704&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5374f704"]])

export default __exports__